import React from "react";
import { Box, Typography } from "@mui/material";
import { Info } from "lucide-react";

const INFO_TEXT = {
  purchaseOrders:
    "Purchase order allows you to add products which are not in inventory.",
  orders: "Order management allows you to track and manage customer orders.",
  shipmentOrders:
    "Shipment orders allow you to manage and track orders ready for shipment.",
  createOrder:
    "Create a new order by selecting products and specifying quantities. You can track its status through the ordering process.",
  editOrderDetail:
    "Edit order details, add/remove products, update quantities, apply discounts, and manage payment information.",
  purchaseProducts:
    "The Purchase Products page enables the management of products associated with a purchase order.",
  customers:
    "The Customers page allows you to manage customer information, including adding, editing, and deleting customer records.",
  categories:
    "The Categories page allows you to manage product categories, including adding, editing, and deleting category records.",
  products:
    "The Products page enables comprehensive management of product data, allowing you to create, update, delete, and view product details.",
  productContainers:
    "The Product Containers page enables comprehensive management of product containers, SKU or product name for efficient inventory organization.",
};

const InfoComponent = ({ iconSize = 16, pageKey }) => {
  const text = INFO_TEXT[pageKey] || "No information available.";
  return (
    <Box
      className={`purchase-order-info`}
      display="flex"
      alignItems="center"
      gap={1}
      mt={1}
    >
      <Info size={iconSize} />
      <Typography variant="body2" component="span">
        {text}
      </Typography>
    </Box>
  );
};

export default InfoComponent;
